// extracted by mini-css-extract-plugin
export default {"background":"styles_background__0VHat","container":"styles_container__9yhUJ"};